export const InitialState = {
  authenticated: false,
  connection: "online",
  Profiles: [],
  Tenantes: [],
  usertTypes: [],
  TimeZone: [],
  userDetails: undefined,
  updateList: [],
};

export const reducer = (originalState = InitialState, action) => {
  action = action || {};
  const type = action.type;
  const payload = action.payload;

  let state = { ...originalState };

  switch (type) {
    case "AUTHENTICATED":
      state.user = payload.user;
      state.authenticated = true;
      break;
    case "UNAUTHENTICATED":
      state.authenticated = null;
      break;
    case "UPDATED_USER_LIST":
      state.updateList = payload;
      break;
    default:
      break;
  }

  return state;
};
